import { Divider, Form, Input, InputNumber, Select } from "antd";
import React from "react";
import ReactQuill from "react-quill";

var modules = {
  toolbar: [
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
      { align: [] },
    ],
    [
      {
        color: [
          "#000000",
          "#e60000",
          "#ff9900",
          "#ffff00",
          "#008a00",
          "#0066cc",
          "#9933ff",
          "#ffffff",
          "#facccc",
          "#ffebcc",
          "#ffffcc",
          "#cce8cc",
          "#cce0f5",
          "#ebd6ff",
          "#bbbbbb",
          "#f06666",
          "#ffc266",
          "#ffff66",
          "#66b966",
          "#66a3e0",
          "#c285ff",
          "#888888",
          "#a10000",
          "#b26b00",
          "#b2b200",
          "#006100",
          "#0047b2",
          "#6b24b2",
          "#444444",
          "#5c0000",
          "#663d00",
          "#666600",
          "#003700",
          "#002966",
          "#3d1466",
          "custom-color",
        ],
      },
    ],
  ],
};

var formats = [
  "header",
  "height",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "color",
  "bullet",
  "indent",
  "link",
  "image",
  "align",
  "size",
];

function Description({ form }) {
  return (
    <>
      <div className="text-[#0B363D] font-[600] text-[1.5rem] font-dmSans">
        1. Job Description
      </div>
      <div className="mt-[1rem] mb-[1.5rem]">
        <Divider />
      </div> 
      <Form.Item
        name="jobTitle"
        label={"Job Title"}
        rules={[
          {
            required: true,
            message: "Please add job title",
          },
        ]}
      >
        <Input  className="input lg:!w-[50%]" />
      </Form.Item>

      <Form.Item
        label="Briefly describe what the job entails and specify the job requirements."
        required
      >
        <Form.Item
          name="jobBrief"
          noStyle
          rules={[
            {
              required: true,
              message: "Please add a brief",
            },
          ]}
        >
          <ReactQuill
            theme="snow"
            modules={modules}
            formats={formats}
          
          />
        </Form.Item>
      </Form.Item>
      <Form.Item label="Job requirements" required>
        <Form.Item
          name="jobRequirements"
          noStyle
          rules={[
            {
              required: true,
              message: "Please job requirements",
            },
          ]}
        >
          <ReactQuill
            theme="snow"
            modules={modules}
            formats={formats}
          
          />
        </Form.Item>
      </Form.Item>
      <Form.Item label="Job Responsibilities" required>
        <Form.Item
          name="jobResponsibilities"
          noStyle
          rules={[
            {
              required: true,
              message: "Please job responsibilities",
            },
          ]}
        >
          <ReactQuill
            theme="snow"
            modules={modules}
            formats={formats}  
          />
        </Form.Item>
      </Form.Item>
    </>
  );
}

export default Description;
